import { useState, useEffect, useMemo } from 'react';
import { Link } from "react-router-dom";
import Sidebar from '../Sidebar'
import Header from '../Header'
import HeaderFilters from '../HeaderFilters';

import { GiPoliceOfficerHead } from "react-icons/gi";
import { MdCheck, MdLock, MdWhatsapp  } from "react-icons/md";

import { API_BASE } from '../../config/api';

import ReactApexChart from 'react-apexcharts';

function AccesoSuperLider() {

     const [admin, setAdmin] = useState(null);
  const [loadingAdmin, setLoadingAdmin] = useState(true);

  useEffect(() => {
      const fetchAdmin = async () => {
          try {
              setLoadingAdmin(true);

              const res = await fetch(`${API_BASE}/api/admin/me`, {
                  method: "GET",
                  credentials: "include",
              });

              const data = await res.json();

              if (!res.ok || !data.ok) {
                  throw new Error(data.message || "No se pudo obtener la información del admin");
              }

              setAdmin(data.data);
          } catch (error) {
              console.error("Error al obtener admin:", error);
              setAdmin(null);
          } finally {
              setLoadingAdmin(false);
          }
      };

      fetchAdmin();
  }, []);

  const getLast15DaysDefaultRange = () => {
    const today = new Date();
    const start = new Date(today);

    start.setDate(today.getDate() - 14);

    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");

        return `${yyyy}-${mm}-${dd}`;
    };

    return {
        startDate: formatDate(start),
        endDate: formatDate(today),
    };
};

  // Panel General
    const defaultAccessDates = getLast15DaysDefaultRange();

    const [regions, setRegions] = useState([]);
    const [regionId, setRegionId] = useState("");

    const [distys, setDistys] = useState([]);
    const [grados, setGrados] = useState([]);

    const [distyId, setDistyId] = useState("");
    const [gradoId, setGradoId] = useState("");

    const [startDate, setStartDate] = useState(defaultAccessDates.startDate);
    const [endDate, setEndDate] = useState(defaultAccessDates.endDate);
    const [filtersReady, setFiltersReady] = useState(false);

    const [downloadingExcel, setDownloadingExcel] = useState(false);

    const [summary, setSummary] = useState({
        usuariosRegistrados: 0,
        usuariosActivos: 0,
        usuariosNoActivos: 0,
        usuariosBorrados: 0,
        usuariosMexico: 0,
        usuariosLatam: 0,
        usuariosParticipantes: 0,
        usuariosNoParticipantes: 0,
    });

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

const handleRegionChange = async (value) => {
    setRegionId(value);
    setDistyId("");
    setGradoId("");

    await getFilters({
        nextRegionId: value,
        nextDistyId: "",
    });
};

const handleDistyChange = async (value) => {
    setDistyId(value);
    setGradoId("");

    await getFilters({
        nextRegionId: regionId,
        nextDistyId: value,
        updateRegions: false,
        updateDistys: false,
        updateGrados: true,
    });
};;

const handleGradoChange = (value) => {
    setGradoId(value);
};

    // =============================
    // Cargar filtros iniciales
    // =============================

const getFilters = async ({
    nextRegionId = "",
    nextDistyId = "",
    updateRegions = true,
    updateDistys = true,
    updateGrados = true,
} = {}) => {
    try {
        const params = new URLSearchParams();

        if (nextRegionId) params.append("regionId", nextRegionId);
        if (nextDistyId) params.append("distyId", nextDistyId);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/filters?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.success) {
            throw new Error(result.message || "Error al obtener filtros.");
        }

        if (updateRegions) {
            setRegions(result.data?.regions || []);
        }

        if (updateDistys) {
            setDistys(result.data?.distys || []);
        }

        if (updateGrados) {
            setGrados(result.data?.grados || []);
        }

        return result.data;
    } catch (error) {
        console.error("Error filtros HomeSuperLider:", error);
        setError(error.message);
        return null;
    }
};

useEffect(() => {
    const initFilters = async () => {
        try {
            const data = await getFilters({
                updateRegions: true,
                updateDistys: true,
                updateGrados: true,
            });

            const defaultRegionId = String(data?.defaultRegionId || "");

            setRegionId(defaultRegionId);
            setDistyId("");
            setGradoId("");

            setStartDate(defaultAccessDates.startDate);
            setEndDate(defaultAccessDates.endDate);

            if (defaultRegionId) {
                await getFilters({
                    nextRegionId: defaultRegionId,
                    nextDistyId: "",
                    updateRegions: false,
                    updateDistys: true,
                    updateGrados: true,
                });
            }
        } catch (error) {
            console.error("Error al inicializar filtros:", error);
        } finally {
            setFiltersReady(true);
        }
    };

    initFilters();
}, []);

// Panel de Acceso 
const [datosAcceso, setDatosAcceso] = useState({
    registrosTotales: 0,
    usuariosLogueados: 0,
    usuariosNoLogueados: 0,
    tasaLogin: 0,
    tasaNoLogin: 0,

    pieAccesos: {
        labels: ["Logueados", "No logueados"],
        series: [0, 0],
    },

    topUsuariosAccesos: [],

    tendenciaRegistros: {
        categories: [],
        series: [],
    },

    tendenciaLogins: {
        categories: [],
        series: [],
    },
});

const [loadingDatosAcceso, setLoadingDatosAcceso] = useState(false);

// =============================
// Obtener datos de acceso - Super Líder
// =============================
const getDatosAccesoSuperLider = async () => {
    try {
        setLoadingDatosAcceso(true);
        setError("");

        const params = new URLSearchParams();

        if (regionId) params.append("regionId", regionId);
        if (distyId) params.append("distyId", distyId);
        if (gradoId) params.append("gradoId", gradoId);
        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);

        const response = await fetch(
            `${API_BASE}/api/admin/dashboard/superlider-datos-acceso?${params.toString()}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        const result = await response.json();

        if (!response.ok || !result.ok) {
            throw new Error(result.message || "Error al obtener datos de acceso.");
        }

        setDatosAcceso({
            registrosTotales: Number(result.data?.registrosTotales || 0),
            usuariosLogueados: Number(result.data?.usuariosLogueados || 0),
            usuariosNoLogueados: Number(result.data?.usuariosNoLogueados || 0),
            tasaLogin: Number(result.data?.tasaLogin || 0),
            tasaNoLogin: Number(result.data?.tasaNoLogin || 0),

            pieAccesos: result.data?.pieAccesos || {
                labels: ["Logueados", "No logueados"],
                series: [0, 0],
            },

            topUsuariosAccesos: result.data?.topUsuariosAccesos || [],

            tendenciaRegistros: result.data?.tendenciaRegistros || {
                categories: [],
                series: [],
            },

            tendenciaLogins: result.data?.tendenciaLogins || {
                categories: [],
                series: [],
            },
        });
    } catch (error) {
        console.error("Error datos acceso Super Líder:", error);
        setError(error.message);
    } finally {
        setLoadingDatosAcceso(false);
    }
};

useEffect(() => {
    if (!filtersReady) return;

    getDatosAccesoSuperLider();
}, [
    filtersReady,
    regionId,
    distyId,
    gradoId,
    startDate,
    endDate,
]);

// Grafica Pastel 
const pieAccesosOptions = useMemo(() => ({
    chart: {
        width: 380,
        type: "pie",
    },
    labels: datosAcceso.pieAccesos.labels,
    theme: {
        monochrome: {
            enabled: true,
        },
    },
    plotOptions: {
        pie: {
            dataLabels: {
                offset: -5,
            },
        },
    },
    grid: {
        padding: {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        },
    },
    dataLabels: {
        formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, `${val.toFixed(1)}%`];
        },
    },
    legend: {
        show: true,
        position: "bottom",
    },
}), [datosAcceso.pieAccesos.labels]);

// Tendencia de Registros 
const registrosLineOptions = useMemo(() => ({
    chart: {
        type: "line",
        toolbar: {
            show: true,
        },
        zoom: {
            enabled: true,
        },
    },
    stroke: {
        curve: "smooth",
        width: 3,
    },
    markers: {
        size: 3,
    },
    xaxis: {
        categories: datosAcceso.tendenciaRegistros.categories,
    },
    yaxis: {
        title: {
            text: "Usuarios",
        },
    },
    legend: {
        position: "bottom",
    },
    tooltip: {
        shared: true,
        intersect: false,
    },
}), [datosAcceso.tendenciaRegistros.categories]);

// Tendencia de Logins 
const loginsMixedOptions = useMemo(() => ({
    chart: {
        type: "line",
        stacked: false,
        toolbar: {
            show: true,
        },
    },
    stroke: {
        width: [0, 4],
        curve: "smooth",
    },
    plotOptions: {
        bar: {
            columnWidth: "45%",
        },
    },
    xaxis: {
        categories: datosAcceso.tendenciaLogins.categories,
    },
    yaxis: [
        {
            title: {
                text: "Logins",
            },
        },
        {
            opposite: true,
            title: {
                text: "Usuarios únicos",
            },
        },
    ],
    legend: {
        position: "bottom",
    },
    tooltip: {
        shared: true,
        intersect: false,
    },
}), [datosAcceso.tendenciaLogins.categories]);

    return (
        <>
        <Sidebar/>
        <main class="main-content">
            <Header/>
            <div class="content-inner container-fluid pb-0" id="page_layout">
            <HeaderFilters
                    title="Datos de Acceso"
                    subtitle="Panel Super Líder"

                    regions={regions}
                    distys={distys}
                    grados={grados}

                    regionId={regionId}
                    distyId={distyId}
                    gradoId={gradoId}

                    startDate={startDate}
                    endDate={endDate}

                    onRegionChange={handleRegionChange}
                    onDistyChange={handleDistyChange}
                    onGradoChange={handleGradoChange}
                    onStartDateChange={setStartDate}
                    onEndDateChange={setEndDate}
                />

                
                <div className="row">
                    <div class="col-lg-4 col-md-6">
                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="bg-info text-white rounded p-3">
                                    <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                        <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                    </svg>
                                    </div>
                                    <div class="text-end">
                                    Registros totales
                                        <h2 class="counter" style={{visibility: 'visible'}}>
                                            {loadingDatosAcceso
                                            ? "..."
                                            : datosAcceso.registrosTotales.toLocaleString("es-MX")}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-body">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="bg-info text-white rounded p-3">
                                    <svg class="icon-20" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M11.9488 14.54C8.49884 14.54 5.58789 15.1038 5.58789 17.2795C5.58789 19.4562 8.51765 20.0001 11.9488 20.0001C15.3988 20.0001 18.3098 19.4364 18.3098 17.2606C18.3098 15.084 15.38 14.54 11.9488 14.54Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M11.949 12.467C14.2851 12.467 16.1583 10.5831 16.1583 8.23351C16.1583 5.88306 14.2851 4 11.949 4C9.61293 4 7.73975 5.88306 7.73975 8.23351C7.73975 10.5831 9.61293 12.467 11.949 12.467Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M21.0881 9.21923C21.6925 6.84176 19.9205 4.70654 17.664 4.70654C17.4187 4.70654 17.1841 4.73356 16.9549 4.77949C16.9244 4.78669 16.8904 4.802 16.8725 4.82902C16.8519 4.86324 16.8671 4.90917 16.8895 4.93889C17.5673 5.89528 17.9568 7.0597 17.9568 8.30967C17.9568 9.50741 17.5996 10.6241 16.9728 11.5508C16.9083 11.6462 16.9656 11.775 17.0793 11.7948C17.2369 11.8227 17.3981 11.8371 17.5629 11.8416C19.2059 11.8849 20.6807 10.8213 21.0881 9.21923Z" fill="currentColor"></path>
                                        <path d="M22.8094 14.817C22.5086 14.1722 21.7824 13.73 20.6783 13.513C20.1572 13.3851 18.747 13.205 17.4352 13.2293C17.4155 13.232 17.4048 13.2455 17.403 13.2545C17.4003 13.2671 17.4057 13.2887 17.4316 13.3022C18.0378 13.6039 20.3811 14.916 20.0865 17.6834C20.074 17.8032 20.1698 17.9068 20.2888 17.8888C20.8655 17.8059 22.3492 17.4853 22.8094 16.4866C23.0637 15.9589 23.0637 15.3456 22.8094 14.817Z" fill="currentColor"></path>
                                        <path opacity="0.4" d="M7.04459 4.77973C6.81626 4.7329 6.58077 4.70679 6.33543 4.70679C4.07901 4.70679 2.30701 6.84201 2.9123 9.21947C3.31882 10.8216 4.79355 11.8851 6.43661 11.8419C6.60136 11.8374 6.76343 11.8221 6.92013 11.7951C7.03384 11.7753 7.09115 11.6465 7.02668 11.551C6.3999 10.6234 6.04263 9.50765 6.04263 8.30991C6.04263 7.05904 6.43303 5.89462 7.11085 4.93913C7.13234 4.90941 7.14845 4.86348 7.12696 4.82926C7.10906 4.80135 7.07593 4.78694 7.04459 4.77973Z" fill="currentColor"></path>
                                        <path d="M3.32156 13.5127C2.21752 13.7297 1.49225 14.1719 1.19139 14.8167C0.936203 15.3453 0.936203 15.9586 1.19139 16.4872C1.65163 17.4851 3.13531 17.8066 3.71195 17.8885C3.83104 17.9065 3.92595 17.8038 3.91342 17.6832C3.61883 14.9167 5.9621 13.6046 6.56918 13.3029C6.59425 13.2885 6.59962 13.2677 6.59694 13.2542C6.59515 13.2452 6.5853 13.2317 6.5656 13.2299C5.25294 13.2047 3.84358 13.3848 3.32156 13.5127Z" fill="currentColor"></path>
                                    </svg>
                                    </div>
                                    <div class="text-end">
                                    Logins totales
                                        <h2 class="counter" style={{visibility: 'visible'}}>
                                            {loadingDatosAcceso
                                            ? "..."
                                            : datosAcceso.usuariosLogueados.toLocaleString("es-MX")}
                                        </h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header d-flex justify-content-between">
                                <div class="header-title text-center" style={{justifyContent:'center'}}>
                                <h4>Usuarios logeados  vs <br/> Usuarios no logeados</h4>
                                </div>
                            </div>
                            <div class="card-body text-center">
                                <ReactApexChart
                                    options={pieAccesosOptions}
                                    series={datosAcceso.pieAccesos.series}
                                    type="pie"
                                    width={380}
                                />
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header d-flex align-items-center justify-content-between">
                                <div class="header-title">
                                    <h4 class="card-title">Usuarios con más accesos</h4>
                                </div>
                            </div>
                            <div class="card-body">
                                {loadingDatosAcceso ? (
                                    <p className="mb-0">Cargando usuarios...</p>
                                ) : datosAcceso.topUsuariosAccesos.length === 0 ? (
                                    <p className="mb-0 text-muted">
                                        No hay usuarios con accesos en el rango seleccionado.
                                    </p>
                                ) : (
                                    <div
                                        style={{
                                            maxHeight: "410px",
                                            overflowY: "auto",
                                            paddingRight: "6px",
                                        }}
                                    >
                                        {datosAcceso.topUsuariosAccesos.map((usuario, index) => (
                                        <div class="iq-social-user-details mb-3" key={usuario.usuarioId}>
                                            <div class="d-flex justify-content-center gap-3">
                                                <img  src={usuario.fotoUrl || "/assets/images/avatars/01.png"} class="img-fluid avatar-48 rounded-circle" aalt={usuario.usuario} loading="lazy" />
                                                <div class="d-flex align-items-center justify-content-between flex-grow-1">
                                                    <div class="me-3">
                                                        <h5 style={{margin:'0px'}}>{usuario.nombre} {usuario.apellido}</h5>
                                                        <small class="text-ellipsis short-1">@{usuario.usuario}</small>
                                                    </div>
                                                    <div>
                                                        {Number(usuario.totalLogins || 0).toLocaleString("es-MX")} Accesos
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-8">
                        <div class="card">
                            <div class="card-header d-flex justify-content-between">
                                <div class="header-title">
                                    <h4>Línea tendencia registros </h4>
                                </div>
                            </div>
                            <div class="card-body text-center">
                                <ReactApexChart
                                    options={registrosLineOptions}
                                    series={datosAcceso.tendenciaRegistros.series}
                                    type="line"
                                    height={330}
                                />
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header d-flex justify-content-between">
                                <div class="header-title">
                                    <h4>Línea tendencia logins</h4>
                                </div>
                            </div>
                            <div class="card-body text-center">
                                <ReactApexChart
                                    options={loginsMixedOptions}
                                    series={datosAcceso.tendenciaLogins.series}
                                    type="line"
                                    height={330}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
        </>
    )
}

export default AccesoSuperLider